import { BREAKPOINTS } from 'javascripts/constants/index';

const mql = window.matchMedia(`(min-width: ${BREAKPOINTS.xl})`);
const $footer = document.getElementById('footer');

export default class Footer {
  constructor($el) {
    this.$el = $el;
    this.$sections = this.$el.querySelectorAll('.footer__section');

    this.options = {
      sectionClass: 'footer__section',
      sectionOpenClass: 'footer__section--open',
      toggleKeycodes: [32, 13, 38, 40],
    };
  }

  init() {
    this.$sections.forEach(($section) => {
      const { id } = $section.querySelector('.footer__section-inner');
      const $header = $section.querySelector('.footer__section-header');

      $header.setAttribute('type', 'button');
      $header.setAttribute('aria-expanded', 'false');
      $header.setAttribute('tabindex', '0');
      $header.setAttribute('aria-controls', id);

      $header.addEventListener('click', this.toggleSection);
      $header.addEventListener('keydown', this.toggleSection);
    });
  }

  deInit() {
    this.$sections.forEach(($section) => {
      const $header = $section.querySelector('.footer__section-header');

      $header.parentNode.classList.remove('footer__section--open');
      $header.removeAttribute('type');
      $header.removeAttribute('aria-expanded');
      $header.removeAttribute('tabindex');
      $header.removeAttribute('aria-controls');

      $header.removeEventListener('click', this.toggleSection);
      $header.removeEventListener('keydown', this.toggleSection);
    });
  }

  toggleSection = (event) => {
    const $el = event.currentTarget;

    // When Keypress
    if (event.keyCode && !this.options.toggleKeycodes.includes(event.keyCode)) {
      // keyUp NOT registered in this.options.toggleKeycodes. TOGGLE
      return false;
    }

    $el.parentNode.classList.toggle('footer__section--open');
    $el.setAttribute(
      'aria-expanded',
      $el.getAttribute('aria-expanded') === 'true'
        ? 'false'
        : 'true',
    );

    return true;
  }
}

if ($footer) {
  const footer = new Footer($footer);

  // Listener
  const onMediaQueryChange = (mq) => {
    const isDesktop = mq.matches;
    if (isDesktop) {
      footer.deInit();
    } else {
      footer.init();
    }
  };

  // Listen on media query changes
  mql.addEventListener('change', onMediaQueryChange);

  // First run
  onMediaQueryChange(mql);
}
